"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportDashboardToPdf = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var internal_1 = require("../../../internal");
var utils_1 = require("../utils");
/**
 * Hook allowing to export a dashboard to a PDF
 * @param config - configuration of the hook
 * @internal
 */
function useExportDashboardToPdf(_a) {
    var dashboard = _a.dashboard, filters = _a.filters, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useExportDashboardToPdf");
    utils_1.workspaceInvariant(effectiveWorkspace, "useExportDashboardToPdf");
    var promise = dashboard
        ? function () {
            var _a;
            return effectiveBackend
                .workspace(effectiveWorkspace)
                .dashboards()
                .exportDashboardToPdf(dashboard, (_a = filters === null || filters === void 0 ? void 0 : filters.map(internal_1.dashboardFilterToFilterContextItem)) !== null && _a !== void 0 ? _a : undefined);
        }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        dashboard,
        filters,
    ]);
}
exports.useExportDashboardToPdf = useExportDashboardToPdf;
//# sourceMappingURL=useExportDashboardToPdf.js.map